import type { Reminder } from './api';
import type { TranscriptMessage } from './components';

export function splitTranscript(
  transcript:
    | NonNullable<NonNullable<Reminder['aiCall']>['feedback']>['transcript']
    | null
    | undefined,
): TranscriptMessage[] {
  if (!transcript) {
    return [];
  }

  const lines = transcript.split('\n').filter(line => line.trim() !== '');

  const messages = lines.map((line, index) => {
    const aiMatch = line.match(/^AI:\s*(.*)$/i);
    const userMatch = line.match(/^User:\s*(.*)$/i);

    if (aiMatch) {
      return {
        content: aiMatch[1].trim(),
        speaker: 'AI' as const,
        index,
      };
    }

    if (userMatch) {
      return {
        content: userMatch[1].trim(),
        speaker: 'User' as const,
        index,
      };
    }

    // Fallback for lines without clear prefixes - assume alternating pattern
    const speaker: 'AI' | 'User' = index % 2 === 0 ? 'AI' : 'User';
    return {
      content: line.trim(),
      speaker,
      index,
    };
  });

  return messages;
}
